module.exports = __webpack_public_path__ + "img/ring_y_o_null_null.c1977879.png";